<div class="overlay" (mousedown)="onOverlayClicked($event)" @fadeAnimationVoid>
    <div class="dialog-wrapper" (mousedown)="onDialogClicked($event)">
        <ng-template dialogInsertion> </ng-template>
    </div>
</div>
